class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
        this.addEventListener('click', this.handleClick.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
      this.initializeCartOperations(); // Initialize cart operations on open

    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  handleClick(event) {
    const addToCartButton = event.target.closest('.add-to-cart-button');
    if (addToCartButton) {
      event.preventDefault();
      this.addToCart(addToCartButton);
    }
  }

  addToCart(button) {
    const variantId = button.getAttribute('data-variant-id');
    const quantity = button.getAttribute('data-quantity');
    let spinner = button.querySelector('.loading__spinner');
        if (spinner) {
        spinner.classList.remove('hidden');
       }
    button.disabled = true;
    button.style.cursor = 'not-allowed';

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      body: JSON.stringify({
        id: variantId,    
        quantity: quantity 
      }),
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      this.renderCartItems();
      button.disabled = false;
      button.style.cursor = 'pointer';
      spinner.classList.add('hidden');

    })
    .catch(error => {
      button.disabled = false;
      button.style.cursor = 'pointer';
      spinner.classList.add('hidden');
      console.error('There was a problem with the fetch operation:', error);
    });
  }

  initializeCartOperations() {
    const removeButtons = this.querySelectorAll('cart-remove-button');
    removeButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const index = button.getAttribute('data-index');
        this.removeCartItem(index);
      });
    });
  }
  removeCartItem(index) {
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    
    if (cartItems) {
      cartItems.updateQuantity(index, 0); 
    }
  }
  
  
  renderCartItems() {
    const sectionsToRender = this.getSectionsToRender();
  
    const fetchPromises = sectionsToRender.map(section => 
      fetch(`${window.location.pathname}?section_id=${section.id}`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newContent = html.querySelector(section.selector);
  
          const targetElement = document.querySelector(section.selector);
          if (targetElement && newContent) {
            targetElement.innerHTML = newContent.innerHTML;
          }

          if (!this.isCartEmpty()) {
            this.classList.remove('is-empty')
          } else {
            this.classList.add('is-empty')
          }

          setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          });
        })
    );



    Promise.all(fetchPromises)
      .then(() => {
        this.initializeCartOperations();
      })
      .catch((error) => {
        console.error('Error updating cart sections:', error);
      });
  }

  isCartEmpty = () => this.querySelector('.bs-devshop__cart-products-main #CartDrawer-CartItems').childElementCount <= 0

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);



class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


